import { undef as t, get as e, set as o, remove as r } from "@analytics/global-storage-utils";
var a = "localStorage",
    l = c();

function c() {
  if (typeof l !== t) return l;
  l = !0;

  try {
    typeof localStorage !== t && typeof JSON !== t || (l = !1), localStorage.setItem(t, t), localStorage.removeItem(t);
  } catch (t) {
    l = !1;
  }

  return l;
}

function n(t) {
  return l ? localStorage.getItem(t) : e(t);
}

function g(t, e) {
  return l ? localStorage.setItem(t, e) : o(t, e);
}

function u(t) {
  return l ? localStorage.removeItem(t) : r(t);
}

export { a as LOCAL_STORAGE, n as getItem, c as hasLocalStorage, u as removeItem, g as setItem };